import { useCanvasTopBar } from "@/react/components/Mobile/hooks/topBar/useCanvasTopBar";

import { useCanvasPageTitleCrumb } from "./CanvasHeaderContext";

/**
 * Registers the Canvas/AI shell's title+back row into the mobile shell's
 * pinned TopBar via `useCanvasTopBar`, instead of rendering it as ordinary
 * scrolling page content underneath the shell's own default TopBar.
 *
 * Renders nothing when there's no active page title crumb - e.g.
 * `DailyBriefPage`, which registers its own bar via `useCircleAiTopBar`
 * instead and deliberately keeps its crumb empty on mobile to avoid a
 * `topBarOverride` conflict (see `DailyBriefPage.tsx`'s own comment).
 */
export const CanvasMobilePageHeader = () => {
  const pageTitleCrumb = useCanvasPageTitleCrumb();

  return useCanvasTopBar(Boolean(pageTitleCrumb));
};

CanvasMobilePageHeader.displayName = "CanvasMobilePageHeader";
